import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import ActiveDocumentSidebar from './ADSidebar2';
import DocumentList2 from '../DocumentList/DocumentList2';
import { GetWorkflowFromStep } from '../../../actions/WorkflowActions';
import {
  GetADStep,
  GetBP,
  GetBPPermissions,
} from '../../../actions/ActiveDocumentActions';
import { GetUserFieldSettings2 } from '../../../actions/UserSettingActions';
import actionTypes from '../../../actions/ActionTypes';



const BetaActiveDocuments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userSettings = useSelector(state => state.userSettingInfo.value);
  const activeDocs = useSelector(state => state.activeDocumentListInfo.value);
  const [gridData, setGridData] = useState([]);
  const [gridCols, setGridCols] = useState([]);
  const [bpName, setBpName] = useState('');
  const [stepName, setStepName] = useState(undefined);
  const [stepId, setStepId] = useState(0);
  const [bpId, setBPId] = useState(0);
  const [docCount, setDocCount] = useState(0);
  const [formTypeId, setFormTypeId] = useState(0);
  const [fieldSettings, setFieldSettings] = useState([]);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
        document.title = 'TrinDocs - Active Documents'
        checkParams();
  },[]);

  const colWidthChange = (e) => {
    console.log(e);
  }

  useEffect(() => {
    //if(activeDocs.docCount > 0) {
      if(activeDocs.formTypeId !== formTypeId) {
        console.log(activeDocs.formTypeId);
        setFormTypeId(activeDocs.formTypeId);
      } else {
        updateRowData();
      }

    //}

  }, [activeDocs])

  useEffect(() => {
    console.log(formTypeId);
    if(formTypeId !== 0 && userSettings.fieldSettings.formTypeId === formTypeId)
    {
      updateRowData();
    }
    if(formTypeId !== 0 && userSettings.fieldSettings.formTypeId !== formTypeId)
    {
      GetUserFieldSettings2(formTypeId, dispatch);
    }



  }, [userSettings, formTypeId])

  const updateRowData = () => {
    setRefreshing(false);
    let rowData = [];
    if(userSettings.fieldSettings !== undefined  && userSettings.fieldSettings.formTypeId === activeDocs.formTypeId) {
    let fs = {...userSettings.fieldSettings} //.columns.find(f => f.formTypeId === activeDocs.formTypeId)};


    activeDocs.docData.forEach((doc) => {
      let row = { Id: {
        status: doc.status,
        user: doc.checkOutUserName,
        Id: doc.documentId,
        },
        Step: doc.stepName,
        Pages: doc.pageCount,
        Queues: doc.queue === null ? '' : doc.queue,
        Notes: doc.notes,
        Related: doc.relatedCount,
      };


      doc.headers.forEach((head) => {
        row[head.fieldCol] = head.value;
      });
      rowData.push(row);
    });
    let colDefs = [];

    if(fs && fs.columns !== undefined) {
      fs.columns.forEach((col) => {
        let gridCol = { field: col.colName };
        let adCol = activeDocs.columns.find(f => f.fieldId === col.fieldId);
        gridCol.filter = "true";
        gridCol.width = col.colWidth;
        if(adCol && col.fieldId !== null) {
          gridCol.field = adCol.colName;
          gridCol.headerName = adCol.displayName;
          applyColumnType(gridCol, adCol);
        }
        if(col.show === false) {
          gridCol.hide = true;
        } else {
          gridCol.hide = false;
        }
        colDefs.push(gridCol);
      });

    } else {
      activeDocs.columns.forEach((col) => {
        let gridCol = { field: col.colName };
        gridCol.filter = "true"

        gridCol.refData = col;
        applyColumnType(gridCol, col);
        colDefs.push(gridCol);
      });
    }
    setFieldSettings(fs);
    setGridData(rowData);
    setGridCols(colDefs);
    setBpName(activeDocs.bpName);
    setStepName(activeDocs.step ?? undefined);
    setDocCount(activeDocs.docCount);
  }
  }

  const formatNumber = (number, currency) => {
    try {
    let num = number.value;
    num =  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if(num !== '') {
      if(currency === 'GBP'){
        num = '£ '+ num;
      }
      if(currency === 'USD'){
        num = '$ '+ num;
      }
      if(currency === 'EUR'){
        num = '€ '+ num;
      }
      if(currency === 'RUB'){
        num = '₽ '+ num;
      }
      if(currency === 'JPY'){
        num = '¥ '+ num;
      }
      if(currency === 'PHP'){
        num = '₱ '+ num;
      }
    }

    //num = '$ ' + num;//if (num.indexOf('.') < 0) num = num + '.00';
    return num;
    } catch {
      return '';
    }

  }



  const numCompare = (valueA, valueB, nodeA, nodeB, isDescending) => {
    // values arrive as strings; strip group separators so "1,234" sorts numerically
    let numA = parseFloat(String(valueA ?? '').replace(/,/g, ''));
    let numB = parseFloat(String(valueB ?? '').replace(/,/g, ''));
    if(isNaN(numA) && isNaN(numB)) {
      return 0;
    }
    if(isNaN(numA)) {
      return -1;
    }
    if(isNaN(numB)) {
      return 1;
    }
    return numA - numB;
  }

  // date values arrive as fixed-format strings from the server (SQL CONVERT:
  // style 103 when the field format is 'dd/mm/yyyy', style 110 for
  // 'mm-dd-yyyy', otherwise style 101 = mm/dd/yyyy), so parse by the column's
  // own format instead of relying on Date.parse's US-only assumption
  const makeDateParser = (dataFormat) => {
    let dayFirst = dataFormat === 'dd/mm/yyyy';
    return (value) => {
      if(value === null || value === undefined || value === '') return NaN;
      let parts = String(value).split(/[/\-.]/);
      if(parts.length !== 3) return NaN;
      let p0 = parseInt(parts[0], 10);
      let p1 = parseInt(parts[1], 10);
      let year = parseInt(parts[2], 10);
      if(isNaN(p0) || isNaN(p1) || isNaN(year)) return NaN;
      let month = dayFirst ? p1 : p0;
      let day = dayFirst ? p0 : p1;
      return new Date(year, month - 1, day).getTime();
    };
  }

  const dateCompare = (dateA, dateB) => {
    if(isNaN(dateA) && isNaN(dateB)) {
      return 0;
    }
    if(isNaN(dateA)) {
      return -1;
    }
    if(isNaN(dateB)) {
      return 1;
    }
    return dateA - dateB;
  }

  const dateFilterCompare = (filterLocalDateAtMidnight, parsed) => {
    if(isNaN(parsed)) {
      return -1;
    }
    // parsed is already a local-midnight timestamp
    let cellDate = new Date(parsed);
    if(cellDate < filterLocalDateAtMidnight) return -1;
    if(cellDate > filterLocalDateAtMidnight) return 1;
    return 0;
  }

  // sort/filter a column by its typed value (dataType: 1 = number, 2 = date);
  // the cell displays the field value exactly as stored — no reformatting
  const applyColumnType = (gridCol, adCol) => {
    if(adCol.dataType === 1) {
      // right-align cells only — the numericColumn type also right-aligns the
      // header, which moves its filter icon to the left of the text
      gridCol.cellClass = 'ag-right-aligned-cell';
      gridCol.comparator = numCompare;
      gridCol.filter = 'agNumberColumnFilter';
      // cell values are strings and the number filter compares with strict
      // equality, so hand it a parsed number
      let field = gridCol.field;
      gridCol.filterValueGetter = (params) => {
        let num = parseFloat(String(params.data?.[field] ?? '').replace(/,/g, ''));
        return isNaN(num) ? null : num;
      };
    }
    if(adCol.dataType === 2) {
      let parseDate = makeDateParser(adCol.dataFormat);
      gridCol.comparator = (valueA, valueB) => dateCompare(parseDate(valueA), parseDate(valueB));
      gridCol.filter = 'agDateColumnFilter';
      gridCol.filterParams = {
        buttons: ['reset'],
        comparator: (filterLocalDateAtMidnight, cellValue) =>
          dateFilterCompare(filterLocalDateAtMidnight, parseDate(cellValue)),
      };
    }
  }

  const readDefaultParams = () => {
    let defaultPages = null;
    try {
      defaultPages = JSON.parse(localStorage.getItem('DefaultParams'));
    } catch {}
    if (defaultPages === null || defaultPages === undefined) {
      defaultPages = {
        ActiveDocuments: { BP: null, Step: null },
        Inbox: { BP: null, Step: null },
        Search: { BP: null, Step: null },
      };
    }
    if (defaultPages.ActiveDocuments == null) {
      defaultPages.ActiveDocuments = { BP: null, Step: null };
    }
    return defaultPages;
  }

  const LoadStep = (id, bpId, showCompletedDocs) => {
    setStepId(parseInt(id, 10));
    setBPId(parseInt(bpId, 10));
    navigate(`/BetaActiveDocuments?Step=${id.toString()}&BP=${bpId.toString()}`);

    let defaultPages = readDefaultParams();
    defaultPages.ActiveDocuments.BP = bpId;
    defaultPages.ActiveDocuments.Step = id;
    localStorage.setItem('DefaultParams', JSON.stringify(defaultPages));
    // a stale 'true' left by the legacy page makes SearchStore concat doc ids
    localStorage.setItem('loadingMore', false);
    GetBPPermissions(bpId);
    console.log('GetADStep call');
    GetADStep(id.toString(), bpId.toString(), 'user', 'asc', 0, showCompletedDocs, dispatch);
    GetWorkflowFromStep(id);
  }

  const LoadBP = (id, completed) => {
    setStepId(0);
    setBPId(parseInt(id, 10));
    navigate(`/BetaActiveDocuments?BP=${id.toString()}`);
    let defaultPages = readDefaultParams();
    defaultPages.ActiveDocuments.BP = id;
    defaultPages.ActiveDocuments.Step = null;
    localStorage.setItem('DefaultParams', JSON.stringify(defaultPages));
    // a stale 'true' left by the legacy page makes SearchStore concat doc ids
    localStorage.setItem('loadingMore', false);
    GetBPPermissions(id);
    console.log('GetBP call');
    GetBP(id, 'user', 'asc', completed === true, 0, dispatch);
  }



  const checkParams = () => {
    let params = new URLSearchParams(window.location.search);
    var stepParam = params.get('Step');
    var bpParam = params.get('BP');

    if (bpParam) {
      GetBPPermissions(parseInt(bpParam, 10));
    }

    if (stepParam) {
      LoadStep(stepParam, bpParam, false);
    }
    if (!stepParam && bpParam) {
      LoadBP(bpParam, false);
    }
    if (!stepParam && !bpParam) {
      // no params in the URL (e.g. the Active Documents header link):
      // fall back to the last viewed step/BP, same as the regular page
      let defaultPages = readDefaultParams();
      if (defaultPages.ActiveDocuments.Step != null) {
        LoadStep(defaultPages.ActiveDocuments.Step, defaultPages.ActiveDocuments.BP, false);
      } else if (defaultPages.ActiveDocuments.BP != null) {
        LoadBP(defaultPages.ActiveDocuments.BP, false);
      }
    }
  }

  const refreshCurrent = () => {
    console.log('refresh');
    console.log(activeDocs);
    setRefreshing(true);
    checkParams();
  }

  const getSearchCriteria = () => {
    let search = {
      searchType: 'activeDocuments',
      stepId: stepId,
      bpId: bpId,
      queryType: '',
      searchText: '',
      activeDocuments: true,
      completedDocuments: false,
      deletedDocuments: false,
    }
    console.log(search);
    // todo:  get formtype query params
    return search;
  }








    return (
      <div className='sidebarLayout d-flex flex-row flex-fill'>
        <ActiveDocumentSidebar
          LoadStepClick={LoadStep}
          LoadBPClick={LoadBP}
          //ChangeComplete={this.ChangeComplete}
        />
        <DocumentList2
          mode='ACTIVE_DOCUMENTS'
          rowData={gridData}
          colDefs={gridCols}
          docCount={docCount}
          stepName={stepName}
          stepId={stepId}
          bpName={bpName}
          onRefresh={refreshCurrent}
          refreshing={refreshing}
          formTypeId={formTypeId}
          columns={activeDocs.columns}
          fieldSettings={fieldSettings}
          getSearch={getSearchCriteria}
          //ExportToExcel={this.onExcelDownloadConfirmation}
        />
      </div>
    );

}

export default BetaActiveDocuments;

